module.exports = __webpack_public_path__ + "img/certifi.9b6918af.png";